import React, { useState, useEffect } from 'react';
import { state } from './store/global';
import API from './lib/api';
import AppRouter from './router';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const res = await API.get('auth/me'); // protected route to get user info
          state.setUser(res.data.user);
          localStorage.setItem('token', res.data.token);
          if (res.data.user.phoneVerified) state.setAuthentication(true);
        } catch (err) {
          console.log('err: ', err);
          localStorage.removeItem('token');
          state.logout();
        }
      }

      setLoading(false);
    };

    checkAuth();
  }, []);

  return (
    <div className="min-h-screen">
      {loading ? <div>Loading...</div> : <AppRouter />}
    </div>
  );
}

export default App;
